import React, { useState } from 'react';
import {
  Button, Input, Select, Space, Typography, notification,
} from 'antd';
import defaultValues from '../../../utils/defaultValues';
import {
  createScreen, getScreens, replaceButton, saveZone,
} from '../../../utils/zoneMutations';

// Создаёт экран и сразу привязывает его к кнопке. Панель остаётся на кнопке.
function NewScreenMiniForm({
  screenId, button, onDone, onCancel,
}) {
  const [values, setValues] = useState({ headTitle: '', type: 'btnScreen' });

  const create = async () => {
    const screen = createScreen(values);
    const withScreen = [...getScreens(), screen];
    const nextScreens = replaceButton(withScreen, screenId, {
      ...button,
      path: screen.screenId,
      params: { name: 'queue', value: 0 },
    });

    const ok = await saveZone(nextScreens, 'Экран создан и привязан');
    if (!ok) return;

    notification.info({ message: `Экран «${screen.headTitle}» доступен на схеме` });
    onDone(screen);
  };

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Typography.Text strong>Новый экран</Typography.Text>
      <Input
        placeholder="Наименование"
        value={values.headTitle}
        onChange={(e) => setValues((prev) => ({ ...prev, headTitle: e.target.value }))}
      />
      <Select
        style={{ width: '100%' }}
        value={values.type}
        onChange={(type) => setValues((prev) => ({ ...prev, type }))}
        options={defaultValues.screenTypes}
      />
      <Space>
        <Button type="primary" disabled={!values.headTitle} onClick={create}>
          Создать и привязать
        </Button>
        <Button onClick={onCancel}>Отмена</Button>
      </Space>
    </Space>
  );
}

export default NewScreenMiniForm;
